angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSettings', [
   function(
   ) {
      return {
         templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSettings.html',
         controller: 'VmHardwareController',
         controllerAs: 'ctrl'
      };
   }]);